/*
	There are a lot of different preview URLs to manage, with different Creatives and Versions needing different links
	to different apps, and different views within those apps.

	For our purposes, these are broadly in the categories the Legacy Preview app,
	and modern Preview (the PRVW project).

	Anything not denoted as "legacy" is assumed to be the modern Preview app.

	This file is intended to centralize and organize these URLs so they can be easily updated
	throughout the app without hunting and pecking.
*/

import {
	TIA_DOMAIN,
	PREVIEW_2_URL,
	PREVIEW_2_ADTYPES
} from "utils/constants";

import { getPRVW } from "utils/Flags";

export function isLegacyPreview(dependentValues = {}) {
	if(getPRVW()){
		return false;
	}
	const { adType, origin } = dependentValues;
	return origin !== "after_effects" && origin !== "imposium" && !PREVIEW_2_ADTYPES.includes(adType);
}

export const PreviewCreative = {
	basic(creativeId){
		// These are the previews used in iframes, without the Preview App UI components
		return `${PREVIEW_2_URL}/basic/${creativeId}`;
	},
	private(creativeId){
		return `${PREVIEW_2_URL}/creative/${creativeId}`;
	},
	multi(creativeIds){
		return `${PREVIEW_2_URL}/creative/${creativeIds.join(',')}`;
	},
	allVersions(creativeId){
		return `${PREVIEW_2_URL}/creative-versions/${creativeId}`;
	},
};

export const PreviewVersion = {
	basic(creativeId, versionName){
		// These are the previews used in iframes, without the Preview App UI components
		return `${PREVIEW_2_URL}/basic/${creativeId}?selectedVersion=${versionName}`;
	},
	private(creativeId, versionName){
		return `${PREVIEW_2_URL}/creative/${creativeId}?panel=versions&selectedVersion=${versionName}`;
	},
};

export const LegacyPreviewCreative = {
	basic(creativeId){
		return `${TIA_DOMAIN}/basic/${creativeId}`;
	},
	private(creativeId){
		return `${TIA_DOMAIN}/tia/${creativeId}`;
	},
	allVersions(creativeId){
		return `${TIA_DOMAIN}/preview/${creativeId}`;
	},
};

export const LegacyPreviewVersion = {
	basic(creativeId, versionName){
		return `${TIA_DOMAIN}/basic/${creativeId}?configurationName=${versionName}`;
	},
	private(creativeId, versionName){
		return `${TIA_DOMAIN}/tia/${creativeId}?configurationName=${versionName}`;
	},
};
